/* EA quote path and first-party measurement. No personal data enters events. */
(function () {
  'use strict';
  const recent = new Map();
  window.eaQPPublish = function (name, params) {
    if (window.Shopify && window.Shopify.designMode) return;
    const safe = params || {};
    const key = name + JSON.stringify(safe);
    const now = Date.now();
    if (now - (recent.get(key) || 0) < 600) return;
    recent.set(key, now);
    // Queue behind the existing Google tag when its asynchronous script is still loading.
    const googleParams = Object.assign({}, safe, { send_to: 'G-7SZVD3SY7F' });
    if (typeof window.gtag === 'function') window.gtag('event', name, googleParams);
    else {
      window.dataLayer = window.dataLayer || [];
      (function () { window.dataLayer.push(arguments); })('event', name, googleParams);
    }
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, safe);
  };

  // Remember only anonymous quote context for Shopify's full-page confirmation.
  const pendingKey = 'ea_pending_contact_quote';
  window.eaQPRememberQuote = function (source, quantity) {
    try {
      sessionStorage.setItem(pendingKey, JSON.stringify({
        createdAt: Date.now(), path: location.pathname, source: source,
        units: Math.max(0, parseInt(quantity, 10) || 0)
      }));
    } catch (_) { /* A blocked storage API must never prevent a quote. */ }
  };
  // Wait for the page's existing asynchronous analytics setup before consuming a confirmation.
  function publishConfirmedContact() {
    if (document.querySelector('[data-ea-quote-success], [data-ea-contact-success]')) {
      let pending;
      try {
        pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
        sessionStorage.removeItem(pendingKey);
      } catch (_) { pending = null; }
      if (pending && Date.now() - pending.createdAt < 1800000 && pending.path === location.pathname) {
        window.eaQPPublish('ea_quote_request', { source: pending.source, units: pending.units });
      }
    }
  }
  if (document.readyState === 'complete') publishConfirmedContact();
  else window.addEventListener('load', publishConfirmedContact, { once: true });

  let cart = null;
  let units = 0;
  let timer;
  let lastAbove = false;
  let sent = false;
  const tagCache = new Map();
  const modal = document.querySelector('[data-ea-quote-modal]');
  if (!modal) return;
  const dialog = modal.querySelector('[role="dialog"]');
  const form = modal.querySelector('form');
  const feedback = modal.querySelector('.ea-quote-modal__feedback');
  const body = modal.querySelector('[data-ea-quote-body]');
  let formerFocus = null;

  async function isGarment(item) {
    if (item.handle === 'customisation' || item.properties?._customisation_method || item.properties?._base_variants || /stubby/i.test(item.product_title || '')) return false;
    if (/hat|cap|beanie|headwear/i.test(item.product_type || '')) return false;
    if (!item.handle) return false;
    if (!tagCache.has(item.handle)) {
      tagCache.set(item.handle, fetch('/products/' + encodeURIComponent(item.handle) + '.js')
        .then(r => r.ok ? r.json() : null)
        .then(p => p ? !String(p.tags || '').toLowerCase().includes('headwear') : false)
        .catch(() => false));
    }
    return tagCache.get(item.handle);
  }

  async function refresh() {
    if (!document.querySelector('[data-ea-cart-quote-link]')) return;
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      cart = await response.json();
      const eligible = await Promise.all(cart.items.map(isGarment));
      units = cart.items.reduce((sum, item, i) => sum + (eligible[i] ? item.quantity : 0), 0);
      document.querySelectorAll('[data-ea-cart-quote-link]').forEach(el => { el.hidden = units < 10; });
      if (units >= 10 && !lastAbove) window.eaQPPublish('ea_bulk_cart_10plus', { units: units });
      lastAbove = units >= 10;
    } catch (e) { /* Keep server-rendered visibility if the cart request fails. */ }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 150); }
  function cartBody() {
    const rows = (cart?.items || []).map((item, i) => {
      const props = Object.entries(item.properties || {}).filter(([,v]) => v != null && v !== '')
        .map(([k,v]) => '  ' + k + ': ' + String(v)).join('\n');
      return (i + 1) + '. ' + item.product_title + ' | ' + item.variant_title + ' | Qty ' + item.quantity + (props ? '\n' + props : '');
    });
    return 'Cart quote request\nGarment units: ' + units + '\n\n' + rows.join('\n\n');
  }
  function open() {
    formerFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('ea-quote-open');
    dialog.focus();
    schedule();
  }
  function close() {
    modal.hidden = true;
    document.body.classList.remove('ea-quote-open');
    formerFocus?.focus();
  }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-ea-quote-open]')) { e.preventDefault(); open(); }
    if (e.target.closest('[data-ea-quote-close]')) close();
  });
  modal.addEventListener('keydown', e => {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]),input:not([type="hidden"]):not([tabindex="-1"]),textarea,a[href]')].filter(el => el.offsetParent);
    if (!focusable.length) return;
    if (e.shiftKey && document.activeElement === focusable[0]) { e.preventDefault(); focusable.at(-1).focus(); }
    else if (!e.shiftKey && document.activeElement === focusable.at(-1)) { e.preventDefault(); focusable[0].focus(); }
  });
  form.addEventListener('submit', async e => {
    if (form.querySelector('[name="contact[website]"]').value) { e.preventDefault(); return; }
    e.preventDefault();
    if (!cart) await refresh();
    if (!cart || units < 10) { feedback.textContent = 'Please add at least 10 garments before requesting a cart quote.'; feedback.hidden = false; return; }
    body.value = cartBody();
    const submit = form.querySelector('[type="submit"]');
    submit.disabled = true;
    feedback.hidden = true;
    try {
      const response = await fetch(form.action, { method:'POST', body:new FormData(form), credentials:'same-origin' });
      if (/challenge|captcha/i.test(response.url)) { window.eaQPRememberQuote('cart', units); form.submit(); return; }
      if (!response.ok) throw new Error('Request failed');
      const html = await response.text();
      const confirmed = /contact_posted=true/i.test(response.url) || /data-ea-quote-success/.test(html);
      if (!confirmed) throw new Error('No confirmation');
      if (!sent) { sent = true; window.eaQPPublish('ea_quote_request', { source:'cart', units:units }); }
      form.reset();
      feedback.textContent = 'Thanks! Your quote request has been sent.';
      feedback.hidden = false;
      feedback.style.color = 'inherit';
      submit.hidden = true;
    } catch (_) {
      feedback.textContent = 'Sorry, that did not send. Please try again or call 0450 204 633.';
      feedback.hidden = false;
    } finally { submit.disabled = false; }
  });
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:updated', schedule);
  if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule);
  document.querySelectorAll('cart-drawer, cart-items').forEach(root => new MutationObserver(schedule).observe(root, { childList:true, subtree:true }));
  schedule();
})();

